import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  InputNumber,
  DatePicker,
  Button,
  Space,
  Table,
} from "antd";
import {
  API_METHODS,
  BLANK_VALUE,
  DEFAULT_DATE_FORMAT,
} from "../../../constants";
import useApi from "../../../hooks/useApi";
import {
  displayFormattedDate,
  formatDateToDayJS,
  getClientConfig,
  getDebtors,
  isEmpty,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";
import dayjs from "dayjs";
import TableComponent from "../../common/table/TableComponent";
import { useLocation, useNavigate } from "react-router-dom";
import PrintPdfModal from "../../common/PrintPdfModal";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

function AddPartyBill(props) {
  const location = useLocation();
  const innerColumns = [
    {
      title: "Date",
      dataIndex: "roDate",
      width: "100px",
      render: (text) => displayFormattedDate(text),
    },
    { title: "RO Number", dataIndex: "id", width: "150px" },
    {
      title: "Publication",
      dataIndex: "publication",
    },
    {
      title: "RO For",
      dataIndex: "client",
      width: "200px",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      isClassified:
        props.isClassified === 1 ||
        (location.state && location.state.isClassified === 1)
          ? true
          : false,
    },
    {
      title: "Amount",
      dataIndex: "roAmount",
    },
    // {
    //   title: "Classified",
    //   dataIndex: "isClassified",
    //   width: "100px",
    //   render: (text) => (text === 0 ? "No" : "Yes"),
    // },
    {
      title: "Page Number",
      dataIndex: "pageNumber",
      render: (text, record) => (
        <Input
          placeholder="Page number"
          onChange={(e) => savePageNumber(e, record.id)}
          value={text}
        ></Input>
      ),
      width: "150px",
    },
    {
      title: "Bill Done",
      dataIndex: "isBillDone",
      render: (text, record) => (
        <Select
          defaultValue={text}
          options={[
            {
              value: 0,
              label: "No",
            },
            {
              value: 1,
              label: "Yes",
            },
          ]}
          onChange={(e) => saveBillDone(e, record.id)}
        />
      ),
      width: "150px",
    },
  ].filter((row) => !row.isClassified);
  const outerColumns = [
    { title: "RO Number", dataIndex: "id", width: "150px" },
    {
      title: "Publication",
      dataIndex: "publication",
    },
    {
      title: "Date Of Insertion",
      dataIndex: "dateOfInsertion",
    },
    {
      title: "Client",
      dataIndex: "client",
    },
    {
      title: "Rate",
      dataIndex: "rate",
      render: (text, record) => (
        <Input
          placeholder="Rate"
          value={record.rate ? record.rate : 0}
          onChange={(e) => rateChanged(e, record)}
        ></Input>
      ),
      isClassified:
        props.isClassified === 1 ||
        (location.state && location.state.isClassified === 1)
          ? true
          : false,
    },
    {
      title: "Amount",
      dataIndex: "roAmount",
      render: (text, record) => (
        <Input
          placeholder="Amount"
          value={record.roAmount ? record.roAmount : 0}
          onChange={(e) => roAmountChanged(e, record)}
        ></Input>
      ),
    },
    {
      title: "Page Number",
      dataIndex: "pageNumber",
      render: (text) => text,
      width: "150px",
    },
    {
      title: "Bill Done",
      dataIndex: "isBillDone",
      render: (text) => {
        if (text === 1) {
          return "Yes";
        } else {
          return "No";
        }
      },
      width: "150px",
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => deleteRecord(record)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ].filter((row) => !row.isClassified);
  const [form] = Form.useForm();
  const [responseData, getRequest] = useApi(
    `/releaseOrder/partyBill`,
    null,
    API_METHODS.GET
  );

  const [billData, getBillData] = useApi("/partyBill/", null, API_METHODS.GET);
  const [response, request] = useApi(
    `/partyBill?isClassified=${props.isClassified}`,
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    "/partyBill",
    null,
    API_METHODS.POST
  );

  const { account, refParty, publication } = getClientConfig();
  const [visible, setVisible] = useState();
  const [innerTableData, setInnerTableData] = useState();
  const [roData, setROData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [outerTableData, setOuterTableData] = useState([]);
  const [inititalVals, setInitialVals] = useState();
  const [pageNumberMaping, setPageNumberMaping] = useState([]);
  const [billDoneMapping, setBillDoneMapping] = useState([]);
  const navigate = useNavigate();
  const [visiblePrint, setVisiblePrint] = useState(false);
  const [pageNumberError, setPageNumberError] = useState();
  const [showROFor, setShowROFor] = useState(false);
  const [visibleBillWithoutRo, setVisibleBillWithoutRo] = useState();
  const [innerForm] = Form.useForm();
  const [loadingSaveButton, setLoadingSaveButton] = useState(false);
  const [exapndedSelectedRowKeys, setExapndedSelectedRowKeys] = useState([]);
  const [expandedSelectedRows, setExpandedSelectedRows] = useState([]);
  const [expandedPageNumberMaping, setExpandedPageNumberMaping] = useState([]);
  const [isBillEditable, setIsBillEditable] = useState(true);

  const savePageNumber = (e, roId) => {
    const newMapping = [...pageNumberMaping];
    const found = newMapping.findIndex((record) => record.roId === roId);
    if (found === -1) {
      newMapping.push({ roId: roId, pageNumber: e.target.value });
    } else {
      newMapping[found].pageNumber = e.target.value;
    }
    setPageNumberMaping(newMapping);
    let newInnerTableData = innerTableData;
    var foundIndex = newInnerTableData.findIndex((data) => data.id == roId);
    newInnerTableData[foundIndex].pageNumber = e.target.value;
    setInnerTableData(newInnerTableData);
  };

  const saveBillDone = (e, roId) => {
    const newMapping = [...billDoneMapping];
    const found = newMapping.findIndex((record) => record.roId === roId);
    if (found === -1) {
      newMapping.push({ roId: roId, isBillDone: e });
    } else {
      newMapping[found].isBillDone = e;
    }
    setBillDoneMapping(newMapping);
    let newInnerTableData = innerTableData;
    var foundIndex = newInnerTableData.findIndex((data) => data.id == roId);
    newInnerTableData[foundIndex].isBillDone = e;
    setInnerTableData(newInnerTableData);
  };

  const deleteRecord = (record) => {
    const { commission, otherChargesInRs, cgstRate, sgstRate, igstRate } =
      form.getFieldsValue();
    const selectedRos = outerTableData.filter((ro) => ro !== record);
    let amount = null;
    let newSelectedRowKeys = selectedRowKeys;
    const index = newSelectedRowKeys.indexOf(record.id);
    if (index > -1) {
      newSelectedRowKeys.splice(index, 1);
    }
    for (let i = 0; i < selectedRos.length; i++) {
      amount = amount + selectedRos[i].roAmount;
    }
    let commissionInRs = commission
      ? Math.round(((amount * commission) / 100) * 1e2) / 1e2
      : 0;
    let taxable =
      amount - commissionInRs + (otherChargesInRs ? otherChargesInRs : 0);
    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;
    form.setFieldsValue({
      total: amount,
      commissionInRs: commissionInRs,
      taxable,
      cgst,
      sgst,
      igst,
      finalBillAmount: Math.round(finalAmount),
      roundOff,
    });
    setOuterTableData(selectedRos);
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedRos);
  };

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    if (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].isBillDone = 1;
      }
    }
    setROData(data);
  }, [responseData]);

  useEffect(() => {
    let initialValues = billData && billData.data && billData.data[0];
    if (initialValues) {
      if (
        location.state.isViewOnly === false &&
        initialValues.finalBillAmount !== initialValues.balanceAmount
      ) {
        setIsBillEditable(false);
        message.error("You can not edit the party bill.Receipt is alredy done");
      }
      setShowROFor(true);
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.invoiceDate = formatDateToDayJS(initialValues.invoiceDate);
      initialValues.isReceiptDone =
        initialValues.balanceAmount > 0 ? false : true;
      form.setFieldsValue(initialValues);
      let data = [];
      data =
        roData &&
        roData.length > 0 &&
        roData.filter((ro) => ro.billForId === initialValues.billForId);
      let newInnerTableData = [];

      if (
        initialValues.roForId === undefined ||
        initialValues.roForId.length === 0
      ) {
        newInnerTableData = data;
      } else if (
        props.isClassified === 1 ||
        (location.state && location.state.isClassified === 1)
      ) {
        newInnerTableData =
          data &&
          data.filter((ro) => initialValues.roForId.includes(ro.clientId));
      } else {
        newInnerTableData =
          data && data.filter((ro) => ro.clientId === initialValues.roForId);
      }

      if (newInnerTableData) {
        for (let i = 0; i < newInnerTableData.length; i++) {
          let expandedData = [];
          let arr = newInnerTableData[i].dateOfInsertion.split(",");
          let roAmount = 0;
          if (newInnerTableData[i].height && newInnerTableData[i].width) {
            roAmount =
              newInnerTableData[i].rate *
              (newInnerTableData[i].height * newInnerTableData[i].width);
          }
          if (arr.length === 1) {
            expandedData.push({
              key: newInnerTableData[i].id.toString() + "0",
              id: newInnerTableData[i].id,
              dateOfInsertion: displayFormattedDate(arr[0]),
              publication: newInnerTableData[i].publication,
              client: newInnerTableData[i].client,
              captionName: newInnerTableData[i].captionName,
              roAmount: roAmount,
              isBillDone: 0,
              height: newInnerTableData[i].height,
              width: newInnerTableData[i].width,
              rate: newInnerTableData[i].rate,
            });
          } else {
            for (let j = 0; j < arr.length; j++) {
              expandedData.push({
                key: newInnerTableData[i].id.toString() + j.toString(),
                id: newInnerTableData[i].id,
                dateOfInsertion: arr[j],
                publication: newInnerTableData[i].publication,
                client: newInnerTableData[i].client,
                captionName: newInnerTableData[i].captionName,
                roAmount: roAmount,
                isBillDone: 0,
                height: newInnerTableData[i].height,
                width: newInnerTableData[i].width,
                rate: newInnerTableData[i].rate,
              });
            }
          }
          newInnerTableData[i].expandedData = expandedData;
        }
      }
      setInnerTableData(newInnerTableData);
      setInitialVals(initialValues);
      if (!isEmpty(initialValues.roData)) {
        setOuterTableData(initialValues.roData);
        let keys = [];
        let exapndedSelectedRowKey = [];

        for (let i = 0; i < initialValues.roData.length; i++) {
          //for main record
          if (isEmpty(initialValues.roData[i].key)) {
            keys.push(initialValues.roData[i].id);
          } //for expanded records
          else {
            newInnerTableData?.forEach((r) => {
              r.expandedData.forEach((e) => {
                if (e.key === initialValues.roData[i].key) {
                  e.pageNumber = initialValues.roData[i].pageNumber;
                  e.isBillDone = initialValues.roData[i].isBillDone;
                  r.selectedExpandedKeys = r.selectedExpandedKeys
                    ? r.selectedExpandedKeys
                    : [];
                  r.selectedExpandedKeys.push(e.key);
                  exapndedSelectedRowKey.push(e.key);
                }
              });
            });
          }
        }

        setSelectedRows(initialValues.roData);
        setSelectedRowKeys(keys);
        setExapndedSelectedRowKeys(exapndedSelectedRowKey);
      }
    } else if (billData.error) {
      if (
        props.isClassified === 1 ||
        (location && location.state && location.state.isClassified === 1)
      ) {
        navigate("/portal/partyBillClassified");
      } else {
        navigate("/portal/partyBill");
      }
    }
  }, [billData]);

  useEffect(() => {
    // getRequest();
    if (location.state && location.state.isClassified) {
      getRequest(
        null,
        API_METHODS.GET,
        `/releaseOrder/partyBill?isClassified=${location.state.isClassified}`
      );
    } else {
      getRequest(
        null,
        API_METHODS.GET,
        `/releaseOrder/partyBill?isClassified=${props.isClassified}`
      );
    }
  }, []);

  useEffect(() => {
    if (response.data) {
      setLoadingSaveButton(false);
      message.success("Party Bill added successfully.");
      if (props.isClassified === 1) {
        navigate("/portal/partyBillClassified");
      } else {
        navigate("/portal/partyBill");
      }
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      message.success("Party Bill updated successfully.");
      setLoadingSaveButton(false);
      if (location.state && location.state.isClassified === 1) {
        navigate("/portal/partyBillClassified");
      } else {
        navigate("/portal/partyBill");
      }
    }
  }, [editResponse]);

  useEffect(() => {
    if (location.state && location.state.bill_id) {
      getBillData(
        null,
        API_METHODS.GET,
        `/partyBill/${location.state.bill_id}?isClassified=${location.state.isClassified}`
      );
    }
  }, [location.state]);

  const billForChanged = (billForId) => {
    setShowROFor(true);
    let data =
      roData && roData.length > 0
        ? roData.filter((ro) => ro.billForId === billForId)
        : [];
    if (location.state && billForId === inititalVals.billForId) {
      if (inititalVals.roData) {
        let keys = [];
        for (let i = 0; i < inititalVals.roData.length; i++) {
          keys.push(inititalVals.roData[i].id);
        }
        setOuterTableData(inititalVals.roData);
        setSelectedRows(inititalVals.roData);
        setSelectedRowKeys(keys);
      }
      form.setFieldsValue(inititalVals);
    } else {
      let invoiceDate = form.getFieldValue("invoiceDate");
      setOuterTableData();
      setSelectedRows([]);
      setSelectedRowKeys([]);
      form.resetFields();
      form.setFieldValue("invoiceDate", invoiceDate);
    }
    //get commission
    const selectedAccount = account.find((a) => a.id === billForId);
    form.setFieldsValue({
      billForId: billForId,
      commission: !isEmpty(selectedAccount.commission)
        ? selectedAccount.commission
        : 0,
    });

    for (let i = 0; i < data.length; i++) {
      let expandedData = [];
      let arr = data[i].dateOfInsertion.split(",");
      let roAmount = 0;
      if (data[i].height && data[i].width) {
        roAmount = data[i].rate * (data[i].height * data[i].width);
      }
      if (arr.length === 1) {
        expandedData.push({
          key: data[i].id.toString() + "0",
          id: data[i].id,
          dateOfInsertion: displayFormattedDate(arr[0]),
          publication: data[i].publication,
          client: data[i].client,
          captionName: data[i].captionName,
          roAmount: roAmount,
          isBillDone: 0,
          height: data[i].height,
          width: data[i].width,
          rate: data[i].rate,
        });
      } else {
        for (let j = 0; j < arr.length; j++) {
          expandedData.push({
            key: data[i].id.toString() + j.toString(),
            id: data[i].id,
            dateOfInsertion: arr[j],
            publication: data[i].publication,
            client: data[i].client,
            captionName: data[i].captionName,
            roAmount: roAmount,
            isBillDone: 0,
            height: data[i].height,
            width: data[i].width,
            rate: data[i].rate,
          });
        }
      }
      data[i].expandedData = expandedData;
    }
    setInnerTableData(data);
  };

  const roForChanged = (roForId) => {
    let invoiceDate = form.getFieldValue("invoiceDate");
    let billForId = form.getFieldValue("billForId");
    let commission = form.getFieldValue("commission");
    let newInnerTableData = [];
    let data =
      roData && roData.length > 0
        ? roData.filter((ro) => ro.billForId === billForId)
        : [];
    if (roForId === undefined || roForId.length === 0) {
      newInnerTableData = data;
    } else if (
      props.isClassified === 1 ||
      (location.state && location.state.isClassified === 1)
    ) {
      newInnerTableData = data.filter((ro) => roForId.includes(ro.clientId));
    } else {
      newInnerTableData = data.filter((ro) => ro.clientId === roForId);
    }
    setOuterTableData();
    setSelectedRows([]);
    setSelectedRowKeys([]);
    form.resetFields();
    form.setFieldsValue({ invoiceDate, billForId, roForId, commission });
    setInnerTableData(newInnerTableData);
  };

  const setModalVisible = () => {
    setVisible(true);
  };

  const cancel = () => {
    setPageNumberError(null);
    setVisible(false);
  };

  const roSelected = () => {
    let newSelectedRows = [...selectedRows];
    if (expandedSelectedRows.length !== 0) {
      expandedSelectedRows.forEach((row) => addPageNumberToExapndedData(row));
    }
    newSelectedRows = [...new Set([...expandedSelectedRows, ...selectedRows])];

    if (newSelectedRows) {
      let pageNumberError;
      for (let i = 0; i < newSelectedRows.length; i++) {
        pageNumberError = isEmpty(newSelectedRows[i].pageNumber)
          ? "Page number(s) are required."
          : null;
        setPageNumberError(pageNumberError);
        if (pageNumberError) return;
      }
    }

    const { commission, otherChargesInRs, cgstRate, sgstRate, igstRate } =
      form.getFieldsValue();
    let amount = 0;

    if (isEmpty(pageNumberError)) {
      newSelectedRows.forEach(function (outerTableRecord) {
        if (
          outerTableRecord.key ||
          outerTableRecord.dateOfInsertion.split(",").length > 1
        ) {
        } else {
          outerTableRecord.dateOfInsertion = displayFormattedDate(
            outerTableRecord.dateOfInsertion
          );
        }
      });

      if (!isEmpty(outerTableData)) {
        newSelectedRows = [
          ...new Set([
            ...outerTableData,
            ...selectedRows,
            ...expandedSelectedRows,
          ]),
        ];
      }

      for (let i = 0; i < newSelectedRows.length; i++) {
        amount =
          amount +
          (newSelectedRows[i].roAmount ? newSelectedRows[i].roAmount : 0);
      }
      let commissionInRs = commission
        ? Math.round(((amount * commission) / 100) * 1e2) / 1e2
        : 0;
      let taxable =
        amount - commissionInRs + (otherChargesInRs ? otherChargesInRs : 0);
      let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
      let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
      let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

      let finalAmount = taxable + cgst + sgst + igst;
      let roundOff =
        Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;
      form.setFieldsValue({
        total: amount,
        commissionInRs,
        taxable,
        cgst,
        sgst,
        igst,
        finalBillAmount: Math.round(finalAmount),
        roundOff,
      });

      setOuterTableData(newSelectedRows);
      setVisible(false);
    }
  };

  const addPageNumberToExapndedData = (row) => {
    for (let i = 0; i < expandedPageNumberMaping.length; i++) {
      if (expandedPageNumberMaping[i].key === row.key) {
        row.pageNumber = expandedPageNumberMaping[i].pageNumber;
      }
    }
    return row;
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const totalAmountChanged = () => {
    const {
      total,
      commission,
      otherChargesInRs,
      cgstRate,
      sgstRate,
      igstRate,
    } = form.getFieldsValue();
    let commissionInRs = commission
      ? Math.round(((total * commission) / 100) * 1e2) / 1e2
      : 0;

    let taxable =
      total - commissionInRs + (otherChargesInRs ? otherChargesInRs : 0);
    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;
    form.setFieldsValue({
      commissionInRs,
      taxable,
      cgst,
      sgst,
      igst,
      roundOff,
      finalBillAmount: Math.round(finalAmount),
    });
  };

  const commissionChanged = () => {
    const {
      total,
      commission,
      otherChargesInRs,
      cgstRate,
      sgstRate,
      igstRate,
    } = form.getFieldsValue();

    let commissionInRs = Math.round(((total * commission) / 100) * 1e2) / 1e2;
    let taxable =
      total - commissionInRs + (otherChargesInRs ? otherChargesInRs : 0);
    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;

    form.setFieldsValue({
      commissionInRs: commissionInRs,
      taxable,
      cgst,
      sgst,
      igst,
      roundOff,
      finalBillAmount: Math.round(finalAmount),
    });
  };

  const otherChargesChanged = () => {
    const {
      total,
      commissionInRs,
      otherChargesInRs,
      cgstRate,
      sgstRate,
      igstRate,
    } = form.getFieldsValue();

    let taxable =
      total - (commissionInRs ? commissionInRs : 0) + otherChargesInRs;
    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;

    form.setFieldsValue({
      taxable,
      cgst,
      sgst,
      igst,
      roundOff,
      finalBillAmount: Math.round(finalAmount),
    });
  };

  const cgstRateChanged = () => {
    const { taxable, cgstRate, sgst, igst } = form.getFieldsValue();
    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;

    form.setFieldsValue({
      cgst,
      roundOff,
      finalBillAmount: Math.round(finalAmount),
    });
  };
  const sgstRateChanged = () => {
    const { taxable, sgstRate, cgst, igst } = form.getFieldsValue();
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;

    form.setFieldsValue({
      sgst,
      roundOff,
      finalBillAmount: Math.round(finalAmount),
    });
  };
  const igstRateChanged = () => {
    const { taxable, igstRate, cgst, sgst } = form.getFieldsValue();
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;
    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;

    form.setFieldsValue({
      igst,
      roundOff,
      finalBillAmount: Math.round(finalAmount),
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const setModalVisibleBillWithoutRo = () => {
    setVisibleBillWithoutRo(true);
  };

  const cancelDirectBillModal = () => {
    setVisibleBillWithoutRo(false);
  };

  const getActualAmount = (roAmount) => {
    const { commission, cgstRate, sgstRate, igstRate } = form.getFieldsValue();
    let commissionInRs = commission
      ? Math.round(((roAmount * commission) / 100) * 1e2) / 1e2
      : 0;

    let taxable = roAmount - commissionInRs;
    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

    let actualAmount = taxable + cgst + sgst + igst;
    return Math.round(actualAmount);
  };

  const rateChanged = (e, record) => {
    let amount = 0;
    let numberOfDates = record.dateOfInsertion.split(",").length;
    let newOuterTableData = [...outerTableData];
    if ("key" in record) {
      newOuterTableData.forEach(function (outerTableRecord) {
        if (outerTableRecord.key === record.key) {
          outerTableRecord.rate = Number(e.target.value);
          outerTableRecord.roAmount =
            Number(e.target.value) *
            (record.height * record.width) *
            numberOfDates;
        }
      });
    } else {
      newOuterTableData.forEach(function (outerTableRecord) {
        if (outerTableRecord.id === record.id) {
          outerTableRecord.rate = Number(e.target.value);
          outerTableRecord.roAmount =
            Number(e.target.value) *
            (record.height * record.width) *
            numberOfDates;
        }
      });
    }
    for (let i = 0; i < newOuterTableData.length; i++) {
      amount = amount + newOuterTableData[i].roAmount;
    }
    const { commission, otherChargesInRs, cgstRate, sgstRate, igstRate } =
      form.getFieldsValue();

    let commissionInRs = commission
      ? Math.round(((amount * commission) / 100) * 1e2) / 1e2
      : 0;
    let taxable =
      amount - commissionInRs + (otherChargesInRs ? otherChargesInRs : 0);

    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;

    form.setFieldsValue({
      total: amount,
      commissionInRs,
      taxable,
      cgst,
      sgst,
      igst,
      finalBillAmount: Math.round(finalAmount),
      roundOff,
    });
    setOuterTableData(newOuterTableData);
  };
  const roAmountChanged = (e, record) => {
    let amount = 0;
    let newOuterTableData = [...outerTableData];
    let numberOfDates = record.dateOfInsertion.split(",").length;
    if ("key" in record) {
      newOuterTableData.forEach(function (outerTableRecord) {
        if (outerTableRecord.key === record.key) {
          outerTableRecord.roAmount = Number(e.target.value);
          outerTableRecord.rate = (
            Number(e.target.value) /
            (record.height * record.width * numberOfDates)
          ).toFixed(2);
        }
      });
    } else {
      newOuterTableData.forEach(function (outerTableRecord) {
        if (outerTableRecord.id === record.id) {
          outerTableRecord.roAmount = Number(e.target.value);
          outerTableRecord.rate = (
            Number(e.target.value) /
            (record.height * record.width * numberOfDates)
          ).toFixed(2);
        }
      });
    }

    for (let i = 0; i < newOuterTableData.length; i++) {
      amount = amount + newOuterTableData[i].roAmount;
    }
    const { commission, otherChargesInRs, cgstRate, sgstRate, igstRate } =
      form.getFieldsValue();

    let commissionInRs = commission
      ? Math.round(((amount * commission) / 100) * 1e2) / 1e2
      : 0;
    let taxable =
      amount - commissionInRs + (otherChargesInRs ? otherChargesInRs : 0);

    let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
    let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
    let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

    let finalAmount = taxable + cgst + sgst + igst;
    let roundOff =
      Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;

    form.setFieldsValue({
      total: amount,
      commissionInRs,
      taxable,
      cgst,
      sgst,
      igst,
      finalBillAmount: Math.round(finalAmount),
      roundOff,
    });
    setOuterTableData(newOuterTableData);
  };
  const previousButtonClicked = () => {
    let bill_id = form.getFieldValue("id") - 1;
    getBillData(
      null,
      API_METHODS.GET,
      `/partyBill/${bill_id}?isClassified=${location.state.isClassified}`
    );
  };
  const nextButtonClicked = () => {
    let bill_id = form.getFieldValue("id") + 1;
    getBillData(
      null,
      API_METHODS.GET,
      `/partyBill/${bill_id}?isClassified=${location.state.isClassified}`
    );
  };
  const onFinish = () => {
    form.validateFields().then((values) => {
      if (!loadingSaveButton) {
        setLoadingSaveButton(true);
        if (outerTableData && outerTableData.length > 0) {
          values.roIds = outerTableData.map(function (ro) {
            if (ro.key) {
              if (
                props.isClassified === 1 ||
                (location.state && location.state.isClassified === 1)
              ) {
                return {
                  key: ro.key,
                  id: ro.id,
                  pageNumber: ro.pageNumber,
                  roAmount: ro.roAmount,
                  isBillDone: ro.isBillDone,
                  captionName: ro.captionName,
                  dateOfInsertion: ro.dateOfInsertion,
                  client: ro.client,
                  publication: ro.publication,
                  actualAmount: getActualAmount(ro.roAmount),
                };
              } else {
                return {
                  key: ro.key,
                  id: ro.id,
                  pageNumber: ro.pageNumber,
                  roAmount: ro.roAmount,
                  isBillDone: ro.isBillDone,
                  captionName: ro.captionName,
                  dateOfInsertion: ro.dateOfInsertion,
                  client: ro.client,
                  publication: ro.publication,
                  actualAmount: getActualAmount(ro.roAmount),
                  width: ro.width,
                  height: ro.height,
                  rate: ro.rate,
                };
              }
            } else if (ro.id) {
              if (
                props.isClassified === 1 ||
                (location.state && location.state.isClassified === 1)
              ) {
                return {
                  id: ro.id,
                  pageNumber: ro.pageNumber,
                  roAmount: ro.roAmount,
                  isBillDone: ro.isBillDone,
                  captionName: ro.captionName,
                  dateOfInsertion: ro.dateOfInsertion,
                  client: ro.client,
                  publication: ro.publication,
                  actualAmount: getActualAmount(ro.roAmount),
                };
              } else {
                return {
                  id: ro.id,
                  pageNumber: ro.pageNumber,
                  roAmount: ro.roAmount,
                  isBillDone: ro.isBillDone,
                  captionName: ro.captionName,
                  dateOfInsertion: ro.dateOfInsertion,
                  client: ro.client,
                  publication: ro.publication,
                  actualAmount: getActualAmount(ro.roAmount),
                  width: ro.width,
                  height: ro.height,
                  rate: ro.rate,
                };
              }
            } else {
              return {
                client: ro.client,
                dateOfInsertion: ro.dateOfInsertion,
                pageNumber: ro.pageNumber,
                publication: ro.publication,
                roAmount: ro.roAmount,
                totalDays: ro.totalDays,
                actualAmount: getActualAmount(ro.roAmount),
              };
            }
          });
        }
        if (location && location.state) {
          values.isClassified = location.state.isClassified;
          values.invoiceDate = formatDateToDayJS(values.invoiceDate);

          editRequest(
            values,
            API_METHODS.PUT,
            `/partyBill/${location.state.bill_id}?isClassified=${location.state.isClassified}`
          );
        } else {
          values.isClassified = props.isClassified;
          request(values, API_METHODS.POST);
        }
      }
    });
  };

  const handlePrint = () => {
    const flag = visiblePrint ? false : true;
    setVisiblePrint(flag);
  };

  const isFormDisabled = () => {
    let disabled = true;
    if (isBillEditable && !location.state.isViewOnly) {
      disabled = false;
    }
    return disabled;
  };

  const addDataToOutertable = () => {
    innerForm.validateFields().then((values) => {
      values.dateOfInsertion = displayFormattedDate(values.dateOfInsertion);
      let newOuterTableData = [];
      if (outerTableData && outerTableData.length > 0) {
        newOuterTableData = [...outerTableData];
      }

      newOuterTableData.push(values);
      let amount = 0;
      const { commission, otherChargesInRs, cgstRate, sgstRate, igstRate } =
        form.getFieldsValue();

      for (let i = 0; i < newOuterTableData.length; i++) {
        amount = amount + newOuterTableData[i].roAmount;
      }
      let commissionInRs = commission
        ? Math.round(((amount * commission) / 100) * 1e2) / 1e2
        : 0;
      let taxable =
        amount - commissionInRs + (otherChargesInRs ? otherChargesInRs : 0);
      let cgst = Math.round(((taxable * cgstRate) / 100) * 1e2) / 1e2;
      let sgst = Math.round(((taxable * sgstRate) / 100) * 1e2) / 1e2;
      let igst = Math.round(((taxable * igstRate) / 100) * 1e2) / 1e2;

      let finalAmount = taxable + cgst + sgst + igst;
      let roundOff =
        Math.round((Math.round(finalAmount) - finalAmount) * 1e2) / 1e2;
      form.setFieldsValue({
        total: amount,
        commissionInRs,
        taxable,
        cgst,
        sgst,
        igst,
        finalBillAmount: Math.round(finalAmount),
        roundOff,
      });
      innerForm.resetFields();
      setOuterTableData(newOuterTableData);
      setVisibleBillWithoutRo(false);
    });
  };

  const expandedRowRender = (row) => {
    const expandedRowSelectionChanged = (record, selected) => {
      let newExpandedSelectedRows = [...expandedSelectedRows];
      let newInnerTableData = [...innerTableData];
      if (selected) {
        newExpandedSelectedRows.push(record);
        //set expanded selection
        const selectedExpandedRow = newInnerTableData.find(
          (r) => r.id === record.id
        );
        if (selectedExpandedRow && selectedExpandedRow.selectedExpandedKeys) {
          selectedExpandedRow.selectedExpandedKeys = [
            ...selectedExpandedRow.selectedExpandedKeys,
            ...[record.key],
          ];
        } else {
          selectedExpandedRow.selectedExpandedKeys = [record.key];
        }
      } else {
        newExpandedSelectedRows = expandedSelectedRows.filter(
          (item) => item.key !== record.key
        );

        //set expanded selection
        const selectedExpandedRow = newInnerTableData.find(
          (r) => r.id === record.id
        );
        if (selectedExpandedRow && selectedExpandedRow.selectedExpandedKeys) {
          selectedExpandedRow.selectedExpandedKeys =
            selectedExpandedRow.selectedExpandedKeys.filter(
              (key) => key !== record.key
            );
        }
      }
      setInnerTableData(newInnerTableData);
      setExpandedSelectedRows(newExpandedSelectedRows);
    };

    const saveExpandedPageNumber = (e, key) => {
      const newMapping = [...expandedPageNumberMaping];
      const found = newMapping.findIndex((record) => record.key === key);
      if (found === -1) {
        newMapping.push({ key: key, pageNumber: e.target.value });
      } else {
        newMapping[found].pageNumber = e.target.value;
      }
      setExpandedPageNumberMaping(newMapping);
      let newInnerTableData = innerTableData;
      setInnerTableData(newInnerTableData);
    };

    const columns = [
      {
        title: "Date of Insertion",
        dataIndex: "dateOfInsertion",
        key: "dateOfInsertion",
      },
      {
        title: "Page Number",
        dataIndex: "pageNumber",
        render: (text, record) => (
          <Input
            placeholder="Page number"
            onChange={(e) => saveExpandedPageNumber(e, record.key)}
            value={text}
          ></Input>
        ),
        width: "150px",
      },
      {
        title: "Bill Done",
        dataIndex: "isBillDone",
        render: (text, record) => (
          <Select
            defaultValue={text}
            options={[
              {
                value: 0,
                label: "No",
              },
              {
                value: 1,
                label: "Yes",
              },
            ]}
            onChange={(e) => saveBillDone(e, record.id)}
          />
        ),
        width: "150px",
      },
    ];
    return (
      <Table
        columns={columns}
        dataSource={row.expandedData}
        rowSelection={{
          selectedRowKeys: row.selectedExpandedKeys,
          type: "checkbox",
          onSelect: expandedRowSelectionChanged,
        }}
      />
    ); //pagination={false}
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          invoiceDate: dayjs(),
          cgstRate: 2.5,
          sgstRate: 2.5,
          igstRate: 0,
          igst: 0,
        }}
        onFinish={onFinish}
        disabled={location && location.state && isFormDisabled()}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="id" label="Invoice Number">
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="invoiceDate"
              label="Invoice Date"
              rules={[{ required: true, message: "Invoice Date is required." }]}
            >
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="billForId"
              label="Bill For"
              rules={[{ required: true, message: "Bill For is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onSelect={billForChanged}
              >
                {getDebtors(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {showROFor && (
            <Col span={8}>
              <Form.Item name="roForId" label="RO For">
                <Select
                  mode={
                    props.isClassified === 1 ||
                    (location.state && location.state.isClassified === 1)
                      ? "multiple"
                      : "single"
                  }
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={roForChanged}
                >
                  {getDebtors(account).map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.accountName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          {location && location.state && (
            <Col span={8}>
              <Form.Item name="isReceiptDone" label="Receipt Done">
                <Select
                  defaultValue={false}
                  options={[
                    {
                      value: false,
                      label: "No",
                    },
                    {
                      value: true,
                      label: "Yes",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Form.Item name="refPartyId" label="Ref. Party">
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {!isEmpty(refParty) &&
                  refParty.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.refPartyName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {form.getFieldValue("billForId") && innerTableData && (
          <Button
            type="primary"
            onClick={setModalVisible}
            style={{ marginBottom: 10 }}
          >
            Select Ro's
          </Button>
        )}
        {outerTableData && outerTableData.length > 0 && (
          <TableComponent
            columns={outerColumns}
            tableData={outerTableData}
            clientSideRender={true}
          />
        )}
        <Modal
          title="Select Ro's"
          open={visible}
          onOk={roSelected}
          onCancel={cancel}
          width={1000}
          okText="Save"
          destroyOnClose={true}
          maskClosable={false}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {pageNumberError && (
              <span style={{ color: "red" }}>* {pageNumberError}</span>
            )}
            {/* <TableComponent
              columns={innerColumns}
              tableData={innerTableData}
              rowSelection={rowSelection}
              clientSideRender={true}
            /> */}
            <Table
              columns={innerColumns}
              expandable={{
                expandedRowRender,
              }}
              dataSource={innerTableData}
              rowKey="id"
              rowSelection={rowSelection}
            />
          </Space>
        </Modal>
        {(props.isClassified === 1 ||
          (location.state && location.state.isClassified === 1)) && (
          <Row gutter={16}>
            <Col span={8}>
              <Button
                type="primary"
                onClick={setModalVisibleBillWithoutRo}
                style={{ marginBottom: 10 }}
              >
                Add Without RO
              </Button>
            </Col>
          </Row>
        )}
        <Modal
          title="Direct Bill"
          open={visibleBillWithoutRo}
          onOk={addDataToOutertable}
          onCancel={cancelDirectBillModal}
          width={1000}
          okText="Save"
          destroyOnClose={true}
          maskClosable={false}
        >
          <Form
            layout="vertical"
            form={innerForm}
            initialValues={{
              dateOfInsertion: dayjs().add(1, "day"),
              totalDays: 1,
            }}
          >
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="dateOfInsertion"
                  label="Date of Insertion"
                  rules={[
                    {
                      required: true,
                      message: "Date of Insertion is required.",
                    },
                  ]}
                >
                  <DatePicker format={DEFAULT_DATE_FORMAT} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="client" label="RO For">
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {getDebtors(account).map((option) => (
                      <Select.Option key={option.id} value={option.accountName}>
                        {option.accountName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Total Days"
                  name="totalDays"
                  rules={[
                    { required: true, message: "Total Days is required." },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="publication"
                  label="Publication"
                  rules={[
                    { required: true, message: "Publication is required." },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {publication.map((option) => (
                      <Select.Option
                        key={option.id}
                        value={option.publicationName}
                      >
                        {option.publicationName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Amount"
                  name="roAmount"
                  rules={[{ required: true, message: "Amount is required." }]}
                >
                  <InputNumber />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Page Number"
                  name="pageNumber"
                  rules={[
                    { required: true, message: "Page Number is required." },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="reference"
              label="Reference"
              rules={[{ required: true, message: "Reference is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="Total Amount"
              name="total"
              rules={[{ required: true, message: "Total Amount is required." }]}
            >
              <InputNumber onChange={() => totalAmountChanged()} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="commission" label="Commission %">
              <InputNumber onChange={() => commissionChanged()} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="commissionInRs" label="Commission">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="otherChargesInfo" label="Other Charges Info">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="otherChargesInRs" label="Other Charges">
              <InputNumber onChange={() => otherChargesChanged()} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="taxable" label="Taxable">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="cgstRate" label="CGST %">
              <InputNumber onChange={() => cgstRateChanged()} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="cgst" label="CGST Rs.">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="sgstRate" label="SGST %">
              <InputNumber onChange={() => sgstRateChanged()} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="sgst" label="SGST Rs.">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="igstRate" label="IGST %">
              <InputNumber onChange={() => igstRateChanged()} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="igst" label="IGST Rs.">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="roundOff" label="Round Off">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="finalBillAmount" label="Final Bill Amount">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingSaveButton}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Button
              type="default"
              onClick={() => {
                navigate(-1);
              }}
              disabled={false}
            >
              {location && location.state && location.state.isViewOnly
                ? "Close"
                : "Cancel"}
            </Button>
          </Col>
          {location.state?.isViewOnly && (
            <Col>
              <Button type="primary" onClick={handlePrint} disabled={false}>
                Print
              </Button>
            </Col>
          )}
        </Row>
      </Form>
      {location && location.state && location.state.isViewOnly && (
        <Row justify="space-between">
          <Button type="primary" onClick={previousButtonClicked}>
            <LeftOutlined />
            Previous
          </Button>
          <Button type="primary" onClick={nextButtonClicked}>
            Next
            <RightOutlined />
          </Button>
        </Row>
      )}
      {visiblePrint && (
        <PrintPdfModal
          visible={visiblePrint}
          data={[billData?.data[0]]}
          title={"Invoice"}
          close={handlePrint}
          pdfType="partyBill"
          isClassified={location.state?.isClassified}
        />
      )}
    </div>
  );
}

export default AddPartyBill;
